<language-selector>
    <select
        id="{state.selectId}"
        aria-label="{locale?.t('selectlanguage')}"
        onchange="{handleLanguageChange}"
        class="select select-bordered w-full flex-grow {props.compact ? 'select-sm' : ''}"
        disabled="{state.isChanging}">
        <option
            each="{lang in state.availableLanguages}"
            value="{lang.languageCode}"
            selected="{lang.languageCode === state.currentLanguage}">
            {lang.languageName}
        </option>
    </select>

    <script>
        import { getLocaleService } from '../services/service-loader';

        // Each language-selector instance gets a unique id so the desktop nav
        // and mobile drawer copies don't collide when both are mounted.
        let languageSelectorInstanceCounter = 0;

        export default {
            includeStore: true,

            state: {
                availableLanguages: [],
                currentLanguage: 'en',
                isChanging: false,
                selectId: ''
            },

            onBeforeMount() {
                this.state.selectId = 'language-selector-' + (++languageSelectorInstanceCounter);
            },

            async onMounted() {
                const localeService = await getLocaleService();

                this.state.availableLanguages = localeService.getAvailableLanguages();
                this.state.currentLanguage = localeService.getLanguageCode();

                this.update();
            },

            async handleLanguageChange(e) {
                const newLanguageCode = e.target.value;

                // Prevent multiple clicks
                if (this.state.isChanging) return;

                // Show block UI spinner immediately
                this.store.dispatch({ type: 'incrementRequests' });

                this.state.isChanging = true;
                this.update();

                try {
                    const localeService = await getLocaleService();

                    // Update metalark_locale_login_language in localStorage
                    await localeService.setUserLanguagePreference(newLanguageCode);

                    // Full page reload to re-initialize all components with new language
                    window.location.reload();
                } catch (error) {
                    console.error('[LanguageSelector] Failed to change language:', error);

                    // Hide block UI spinner on error
                    this.store.dispatch({ type: 'decrementRequests' });

                    this.state.isChanging = false;
                    this.update();
                }
            }
        }
    </script>
</language-selector>
